import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire/compat';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import { ServiceWorkerModule, SwUpdate } from '@angular/service-worker';
import * as Sentry from '@sentry/angular-ivy';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessagesModule } from 'primeng/messages';
import { ToastModule } from 'primeng/toast';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout/layout.module';
import { SharedComponentsModule } from './shared/components/shared-components.module';
import { JwtInterceptor, ServerErrorInterceptor } from './shared/interceptors';
import { refreshTokenInitializer, RefreshTokenService } from './shared/services';

import { DatePipe } from '@angular/common';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { initializeApp } from 'firebase/app';
import { DialogModule } from 'primeng/dialog';
import { EditorModule } from 'primeng/editor';
import { MessageModule } from 'primeng/message';
import { environment } from 'src/environments/environment';
initializeApp(environment.firebase);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedComponentsModule,
    LayoutModule,
    HttpClientModule,
    BrowserAnimationsModule,
    DialogModule,
    ConfirmDialogModule,
    ToastModule,
    MessagesModule,
    MessageModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.swUpdate
    }),
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),
    EditorModule
  ],
  providers: [
    DatePipe,
    MessageService,
    ConfirmationService,
    SwUpdate,
    {
      provide: APP_INITIALIZER,
      useFactory: refreshTokenInitializer,
      deps: [RefreshTokenService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ServerErrorInterceptor,
      multi: true
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
        logErrors: true
      })
    },
    {
      provide: Sentry.TraceService,
      deps: [Router]
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
